var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6667 4.99984C12.5872 4.99984 13.3334 4.25365 13.3334 3.33317C13.3334 2.4127 12.5872 1.6665 11.6667 1.6665C10.7463 1.6665 10.0001 2.4127 10.0001 3.33317C10.0001 3.54308 10.0389 3.74392 10.1097 3.92891L5.53215 6.84191C5.22909 6.52823 4.80403 6.33317 4.33341 6.33317C3.41294 6.33317 2.66675 7.07936 2.66675 7.99984C2.66675 8.92031 3.41294 9.6665 4.33341 9.6665C4.80403 9.6665 5.22909 9.47145 5.53215 9.15777L10.1097 12.0708C10.0389 12.2558 10.0001 12.4566 10.0001 12.6665C10.0001 13.587 10.7463 14.3332 11.6667 14.3332C12.5872 14.3332 13.3334 13.587 13.3334 12.6665C13.3334 11.746 12.5872 10.9998 11.6667 10.9998C11.1961 10.9998 10.7711 11.1949 10.468 11.5086L5.89045 8.59557C5.96128 8.41058 6.00008 8.20974 6.00008 7.99984C6.00008 7.78994 5.96128 7.5891 5.89046 7.4041L10.468 4.49111C10.7711 4.80478 11.1961 4.99984 11.6667 4.99984Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.078fdb75.svg";
export { ForwardRef as ReactComponent };